// @ts-strict-ignore
import { UndoMoveArticlesOperation } from './undo-move-articles-operation';
import { IOperation } from './i-operation';
import { Dictionary } from 'typescript-collections';
import { Vector3 } from 'three';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { LayerManager } from '@3d-scene/manager/layer-manager';
import { ArticleMoveManager } from '@project/components/article/manager/article-move.manager';
import { CarrierBlockManager } from '@project/components/article/manager/carrier-block.manager';
import { UnusedLabelingService } from '@project/components/label/label-editor/service/unused-labeling.service';
import { ProjectModel } from '@project/model/project.model';
import { ProjectContentPresenter } from '../../presenter/project-content.presenter';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';

export class UndoCenterArticlesOperation extends UndoMoveArticlesOperation implements IOperation {
  constructor(
    moveArticlesMap: Dictionary<string, Vector3>,
    dispatchMessages: boolean,
    insertArticleUtils: InsertArticleUtils,
    carrierBlockManager: CarrierBlockManager,
    articleMoveManager: ArticleMoveManager,
    layerManager: LayerManager,
    projectContentPresenter: ProjectContentPresenter,
    unusedLabelingService: UnusedLabelingService,
    projectModel: ProjectModel,
    private _blockingZonesOffsetUndoMap: Dictionary<string, number>,
    private _blockingZonesOffsetRedoMap: Dictionary<string, number>,
    private containerService: ContainerService
  ) {
    super(
      carrierBlockManager,
      articleMoveManager,
      layerManager,
      projectContentPresenter,
      unusedLabelingService,
      projectModel,
      insertArticleUtils,
      moveArticlesMap,
      dispatchMessages,
      false,
      true
    );
  }

  public getQualifiedClassName(): string {
    return 'UndoCenterArticlesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public isDistanceBetweenArticlesChanged(): boolean {
    return false;
  }

  public async performRedo(): Promise<void> {
    this._insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, false);
    this.updateBlockingZoneOffsets(this._blockingZonesOffsetRedoMap);
    this.dispatchMoveMessage(true, false);
  }

  public async performUndo(): Promise<void> {
    this._insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, true);
    this.updateBlockingZoneOffsets(this._blockingZonesOffsetUndoMap);
    this.dispatchMoveMessage(true, true);
  }

  private updateBlockingZoneOffsets(offsetsMap: Dictionary<string, number>): void {
    for (const guid of offsetsMap.keys()) {
      const offset: number = offsetsMap.getValue(guid);
      const container: ArticleContainer = this.containerService.findArticleContainerInGlobal(guid);
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(container.articleUsage, ArticleUsageInfoPropertyDef.ARTICLE_OFFSET, offset);
    }
  }
}
